import { useCallback, useEffect, useState } from 'react'

export const CV_PIN_KEY = 'cvPinned'
export const CV_PIN_EVENT = 'cvPinChange'

export const useResumePin = () => {
  const [isPinned, setIsPinned] = useState(
    () => localStorage.getItem(CV_PIN_KEY) === 'true'
  )

  const togglePin = () => {
    const newValue = !isPinned
    localStorage.setItem(CV_PIN_KEY, String(newValue))
    document.dispatchEvent(
      new CustomEvent(CV_PIN_EVENT, { detail: { isPinned: newValue } })
    )
  }

  const handlePinChange = useCallback(() => {
    setIsPinned(localStorage.getItem(CV_PIN_KEY) === 'true')
  }, [])

  useEffect(() => {
    document.addEventListener(CV_PIN_EVENT, handlePinChange)
    return () => {
      document.removeEventListener(CV_PIN_EVENT, handlePinChange)
    }
  }, [handlePinChange])

  return { isPinned, togglePin }
}
